import { withI18n } from 'react-i18next';

import CancelOrderModalMobile from './CancelOrderModalMobile';

export default withI18n()(CancelOrderModalMobile);
